package music.jammers.client.shared.event.presentation.model

import androidx.compose.ui.graphics.Color

data class EventListItem(
    val id: Long,
    val title: String,
    val spot: String,
    val day: String,
    val month: String,
    val hour: String,
    val minutes: String,
    val textColor: Color,
    val backgroundUrl: String,
    val readyTracks: Int,
    val tracksCount: Int,
)